import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SearchX, Home, Wrench, MapPin, Phone, ArrowRight } from "lucide-react";
import { SEO } from "@/components/SEO";

const QUICK_LINKS = [
  { to: "/reparation-iphone-niort", label: "Réparation iPhone Niort" },
  { to: "/reparation-mac-niort", label: "Réparation Mac Niort" },
  { to: "/pannes-reparations", label: "Toutes les pannes & tarifs" },
  { to: "/villes-desservies", label: "Villes desservies (80 km)" },
  { to: "/rendez-vous", label: "Prendre rendez-vous" },
  { to: "/contact", label: "Nous contacter" },
];

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-slate-50 py-16" data-testid="not-found-page">
      <SEO
        title="Page introuvable (404) - Mediastore Niort"
        description="La page que vous recherchez n'existe pas ou a été déplacée. Retrouvez nos services de réparation iPhone, Mac et ordinateur à Niort."
        path="/404"
        noindex={true}
      />
      <div className="container-custom">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-red-100 mb-6">
            <SearchX className="h-10 w-10 text-red-600" />
          </div>
          <p className="text-sm font-semibold text-red-600 uppercase tracking-widest mb-2" data-testid="not-found-code">Erreur 404</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Page introuvable
          </h1>
          <p className="text-slate-600 mb-8 max-w-lg mx-auto">
            La page que vous recherchez n&apos;existe pas ou a été déplacée.
            Pas de panique : nos experts réparent les iPhone, Mac et ordinateurs… mais aussi les liens cassés.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
            <Link to="/" data-testid="not-found-home-link">
              <Button className="w-full sm:w-auto bg-red-600 hover:bg-red-700">
                <Home className="h-4 w-4 mr-2" />
                Retour à l&apos;accueil
              </Button>
            </Link>
            <a href="tel:+33549057490" data-testid="not-found-phone-link">
              <Button variant="outline" className="w-full sm:w-auto">
                <Phone className="h-4 w-4 mr-2" />
                05 49 05 74 90
              </Button>
            </a>
          </div>

          <div className="bg-white rounded-2xl border border-slate-200 p-6 text-left shadow-sm">
            <h2 className="text-base md:text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2">
              <Wrench className="h-5 w-5 text-red-600" />
              Pages les plus consultées
            </h2>
            <ul className="grid sm:grid-cols-2 gap-2" data-testid="not-found-quick-links">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="flex items-center gap-2 text-sm text-slate-600 hover:text-red-600 transition-colors py-1.5"
                  >
                    <ArrowRight className="h-3.5 w-3.5 shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <p className="text-sm text-slate-500 mt-8 flex items-center justify-center gap-2">
            <MapPin className="h-4 w-4" />
            Mediastore — 104 Rue de la Gare, 79000 Niort
          </p>
        </div>
      </div>
    </div>
  );
}
